import './contact.css';

const Contact = () => {

  return (
    <div className='Contact'>
        <h1>Contact me</h1>


        <h4>Best way to contact me is via email!</h4>
        <h3>You can email me at: <strong>ktsami@auth.gr</strong></h3> 

        <h4>My PGP</h4>
        <div className='pgpKey'>
        <p>
            -----BEGIN PGP PUBLIC KEY BLOCK-----
            <br/><br/>
            mQINBGeTcekBEADgeUSDEcqoG1K3vDJZOhvxHLPZWplT3MLguckeQL8/zW7Vrbxh
            oMs/3jiGJfL+EbioQK9bWz5/SEyolD+pDQ9bV8cBZvvThROb1QvjusrhrCIXoEJn
            0JuvFVRBPmN0Sge0QGivBOz/IwK5w5v1UcU3AMgFc/J6UKCl93/OUVcVm6EUItqH
            wjcmkhZ7hF9eOqdRHOk67Bdoff3WxrdKFWeWysreVCLy7o2HsoCK94iMhsEat0Fq
            C0A7N3WFEv55ffJlyPvjvGIWmIND4RAmS9q0NDnJvx4Y6RoAN6FRrIB5MdEKskag
            vZjf8xpqqOWwBtewDrnQvIUgSjm2EhwSGs+3eddLhwCO+YBpXShSwTUORf2KH+p/
            l6UZedzetlwz7//uFGDfPyaW4tyvFZPP1Jfo44rQQfxg+GjtkId199BCQkOMJ6ZD
            ZdUkszRbku4KovRWNjo4J8DNYVujFWXSRmZO5fQLO5EcWa3Jm38wVdKPqwPilg9C
            IxiYNYlXKLgvEeKuY1thHQok4jeHH12F7kMrIKyfRN5NVKZ+H1IejokTipItd23A
            bggHPBrC+lOd1UFiaxRppYDjkXCOm+GM2Lx3SFlEIORgnGCVxMRQ2YJXz7pBO+oG
            260eMPiy0dlG8R5i81NdaBAPyhz4Defc6HJNp8hxFLEIHPh9UBSbgcLc6wARAQAB
            tAZrbGF1c3OJAlQEEwEIAD4WIQRbbIARxHAM3Y2eso2dV9OPSXCsUQUCZ5Nx6QIb
            AwUJB4Ye8gULCQgHAgYVCgkICwIEFgIDAQIeAQIXgAAKCRCdV9OPSXCsUWaLD/wL
            C1Sf958LQrN/obcO9qexYb4hkCNDNsO+UBOTov14e6aINyKYYIArdgZKqAoIStHs
            GLx1n+WQol8pH9GYsBdy3+JSmOs7Fa5XKfZw3ucdDIj6o4uPh1/ktpbUvy6Q+m28
            r2T7fWnDZFcR8R+3Ws5oHjzd6p3YoKUj09zAnPLwn79wBIMvuO8CjnU7SuGPThng
            UCVHstRUgg/dBtj5LwPRj0kOurUQeBUHGB4EC/tLsfLG3o1GKhPu3fl13+9qk315
            Haz82wEfDoce7CI9z6pj8k6SylJtBnFfp6NfDz5fRb/yixFxmsp5C40ZYo2GMl2y
            GkzURo3llltSAO8Lg2Nbv+G6arV0AfPltH3TGeoRSpSFx54IUvosFR+kzYI1Ejl9
            k4+6sC8+OTvgWfsINwXEsgBUqTUj+tQv/C+mgzFT6b+/rSpBUBDlt49EMpKW8bsg
            bDekZzE59W2yVNFYbnp2h9hCGXcaa7ZhTARPPCnGBA7A1wgLv6u3bKuoDJjBiQz0
            s7FyxdEbF6JLhQS1mFuiI1yG4Eg0oh1N10Ig6rl9zBLV/W6ZiwUyl7aFdk6vM7SA
            9sFXoc6SxKWhCtla3pW4iRvOGgXo33bJ1UhQcKeoTdon8lECIDdSrZhGNsB50l7T
            PWfBdqY9HpTkbBzyez7MhY2wiLx9r1Yuc3I36J6HK7kCDQRnk3HpARAAy33RsYGv
            /NzaNed0f0rH1SAiefspERamjIVmE75228jdO+SOfc/KKYE9Hey1ADA623gamp2h
            5mKrJcIA3kRKlVcXt15e/qQmQ2Syf68Aw7dSC6v8+1thmvz2TEwaToZBwfjhYbUC
            nyELvjoQ3Yq+Df8djfL/CsgIA0briK3waRtP6jv/A00eczm0py5Y0Yip3RF/PXwr
            rElL5cNKWRMWmj1WEnjkM3i45s2mGFKS4CxjhYr4X3eOrzz9sgFWmxIpkrD7M/u/
            egUQR4pICNRKL4kkNDckG9avaXnEx4x423UgY0OmLIbUUj0soD0B25OYIUNgZuIU
            vrDIpTJ3sLOcYE6HpGq157ouuIquvdX4t0dfO8RncDYdD5cCD8RA/ywfpI0Ujf3l
            502NK9st4Ty8HpIdrcQgYMvahZHiLImB3AZuDFZYakl1vVZyIzsSxRLwZZG08HYG
            UAILAH2o56HEvrWQ20M0ahq5u2caHeQ3M3YPk9XzxHk3Ms+a7rbhsI+4Jv1/9+cS
            rnKFxqUv/l4fcbeJOEeI/0N2s3+wXqyiZC2y3xGoh+K4O1sofMPO1H2vu11fOCOe
            mTAuf9PHgT31s4c6vMVsQmL163tDP/FnYf7mZONZtxLE/nOT377Lh6ix3120v413
            YvjtXsKXc+72MILAfzFzpAX6tyU2iUmpuS8AEQEAAYkCPAQYAQgAJhYhBFtsgBHE
            cAzdjZ6yjZ1X049JcKxRBQJnk3HpAhsMBQkHhh7yAAoJEJ1X049JcKxRdEsP/RoI
            0YZV8qPsbSmYC8Y5VuFv50oCvb/Xu8U6qAv8olmpe0dtuc8daVfFGKzLXBghX4kY
            ne0gBK9ZaLL/GEpTtEyaYwudDaPeXfLFTXkumhpiaCC3BgMuOHOgf2X+aZRzZL0o
            btYs+YqNFfe58h5Ji3zb5S4BIZIpcfwLfB0dV3g1vQGPQcksn+0Sqmbuv9DcscD4
            C5IRuMwXxe3MCDQ8D7Iq1BHWIqGmksyldd6WLebwz+4/zL2H+hRcTYYExFcs4YtI
            C2bwWSJ0p9d2j88BAlVAZ99BmmchhSX4SgUXswBN7lLZTrXt7SkOrIKllEUAtCxs
            TjcB7itfq5K9vl/4Ns05XiBqPkYKHDqNO7q+sYKV9qASLMlQ9IeW8nDuY8ahf/fQ
            yvSZM91AKLU90r16qLhw7ER52cqC5ZYyVp7bYPD3ALAfqZQ9rTo1pEiSkmm0MDS+
            IvVuUHhRRbr4GqJwclFWsY+Qf6B78QGcMnFSMdtxkjeMyKxw0ZmWOMzyDI00wtIz
            yfQO1vOO2AUXBPZZVfhWRvg39gPI7F4mIWnWKEp7e7ZIWqZ0SDuG/HTPDmGLMIOE
            S1MW2HTyhc7jUeBRO+qugzr7HSO8FBRti+AVuYnAhaXtbzu8qPKF4fEqITco3bEH
            H88/ipfuN6yjAkGimELuusKwuQeS+VR9GuZoYYxf
            =GPoa
            <br/><br/>
            -----END PGP PUBLIC KEY BLOCK-----
        </p>
        </div>
    </div>
  );
}

export default Contact;